import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import UpIcon from 'assets/images/svg/button-next-up.svg'

const ScrollUpBtn = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 320)
    }

    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <Container>
      <button
        type="button"
        aria-label="Scroll to top"
        className={visible ? 'is-visible' : ''}
        onClick={scrollToTop}
      />
    </Container>
  )
}

export default ScrollUpBtn

const Container = styled.div`
  button {
    position: fixed;
    right: 35px;
    bottom: 35px;
    z-index: 999;
    width: 60px;
    height: 60px;
    padding: 8px;
    border: 0;
    border-radius: 50%;
    background-color: transparent;
    background-image: url(${UpIcon});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
    opacity: 0;
    pointer-events: none;
    transform: translateY(10px);
    transition: opacity 180ms ease, transform 180ms ease;
  }

  button.is-visible {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }
`
